import { Component, OnInit } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import {
  ICourseSession,
  IGetQrSessionsParams,
} from "src/app/attendanceRecord/interfaces/SessionsInterface";
import { calendarUtils } from "src/app/calendar/utils/convertDates.utils";
import { SessionsService } from "src/app/services/session/sessions.service";
import { UsersService } from "src/app/manage-users/services/user-services/users.service";
import { IUser } from "src/app/models/Identity/user";

@Component({
  selector: "app-my-qr-filters-global",
  templateUrl: "./my-qr-filters-global.component.html",
  styleUrls: ["./my-qr-filters-global.component.css"],
})
export class MyQrFiltersGlobalComponent implements OnInit {
  // estados
  protected isLoadingTableData: boolean = false;
  protected errorOccurred: boolean = false;

  // fechas
  public startDate: NgbDate | null = null;
  public endDate: NgbDate | null = null;

  // filtros
  public textSearch: string = "";
  public userList: IUser[] = [];
  public selectedUserId: number | null = null;
  public selectedUserName: string = "";
  public isLoadingUsers: boolean = false;
  public userMap: { [key: string]: string } = {};
  public selectedOwner: IUser | null = null;
  public isEditingOwner: boolean = true;

  // paginación
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number = 0;

  // data
  public sessionsList: ICourseSession[] = [];

  constructor(
    private sessionsService: SessionsService,
    private userService: UsersService
  ) {}

  // getters fechas
  get getEndDateSelected() {
    return this.endDate ? calendarUtils.dateStructToDate(this.endDate) : null;
  }

  get getStartDateSelected() {
    return this.startDate
      ? calendarUtils.dateStructToDate(this.startDate)
      : null;
  }

  get getShowDatesError() {
    const { getStartDateSelected: startDate, getEndDateSelected: endDate } =
      this;

    return (
      (startDate && !endDate) ||
      (endDate && !startDate) ||
      (startDate && endDate && startDate > endDate)
    );
  }

  get getFilterAndPaginationParams(): IGetQrSessionsParams {
    return {
      pageNumber: this.page,
      pageSize: this.pageSize,
      textSearch: this.textSearch,
      userId: this.selectedUserId ?? undefined,
      startDate: this.getStartDateSelected
        ? calendarUtils.formatDateToYYYYMMDD(this.getStartDateSelected)
        : "",
      endDate: this.getEndDateSelected
        ? calendarUtils.formatDateToYYYYMMDD(this.getEndDateSelected)
        : "",
    };
  }

  // cargar usuarios
  loadUsers() {
    this.isLoadingUsers = true;

    this.userService.getUsers().subscribe({
      next: users => {
        this.userList = users.filter(u => u.status === 1);

        this.userMap = {};
        this.userList.forEach(user => {
          this.userMap[String(user.personNumber)] = user.name;
        });

        this.isLoadingUsers = false;
      },
      error: () => {
        this.isLoadingUsers = false;
      },
    });
  }

  onUserSelectedFromSearcher(user: IUser | null) {
    this.selectedOwner = user;
    this.selectedUserId = user?.id ?? null;
    this.selectedUserName = user?.name ?? "";

    this.page = 1;
    this.getQrList();
  }

  onUserTyping() {
    this.selectedUserId = null;
  }

  // init
  ngOnInit(): void {
    const today = new Date();

    this.startDate = new NgbDate(today.getFullYear(), 1, 1);
    this.endDate = new NgbDate(today.getFullYear(), 12, 31);

    this.loadUsers();
    this.getQrList();
  }

  // búsqueda manual (ya no se usa para texto)
  onChangeFilterSearch() {
    this.page = 1;
    this.getQrList();
  }

  // cambio de página
  onPageChange(page: number) {
    this.page = page;
    this.getQrList();
  }

  // servicio principal
  getQrList() {
    if (this.isLoadingTableData) {
      return;
    }

    this.isLoadingTableData = true;

    this.sessionsService
      .getAllUsersSessions(this.getFilterAndPaginationParams)
      .subscribe({
        next: ({ data, pagination }) => {
          this.sessionsList = data;
          this.collectionSize = pagination?.totalRegistro ?? data.length;
          this.isLoadingTableData = false;
          this.errorOccurred = false;
        },
        error: () => {
          this.errorOccurred = true;
          this.sessionsList = [];
          this.collectionSize = 0;
          this.isLoadingTableData = false;
        },
      });
  }

  // recargar página
  reloadPage() {
    window.location.reload();
  }
}
